var GoogleMapsLoader = require('google-maps'); // only for common js environments
GoogleMapsLoader.KEY = 'AIzaSyB0j-bBbNiX_P8tejBjYSMh_iI250hGbbc';
var MarkerClusterer = require('node-js-marker-clusterer')
var masonryWrapper = require('./masonryWrapper')
var loadingelementsOnScroll = 0;


var loaderCode = "<svg id=\"logo-animated\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"119px\" height=\"90px\" viewBox=\"0 0 119 90\" version=\"1.1\">\n" +
    "                <!-- Generator: sketchtool 50.2 (55047) - http://www.bohemiancoding.com/sketch -->\n" +
    "                <title>EE6B0E00-542B-4148-85EA-4093D3820EB2</title>\n" +
    "                <desc>Created with sketchtool.</desc>\n" +
    "                <defs/>\n" +
    "                <g id=\"Desktop\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n" +
    "                    <g id=\"Elemente\" transform=\"translate(-254.000000, -7016.000000)\" fill=\"#000000\">\n" +
    "                        <g id=\"Logo_SBF\" transform=\"translate(254.000000, 7016.000000)\">\n" +
    "                            <polygon id=\"Fill-1\" points=\"69.1058053 1.70246512 69.1058053 9.47804651 110.569998 9.47804651 110.569998 82.2231628 22.9964368 82.2231628 22.9964368 90.0008372 118.325875 90.0008372 118.325875 1.70246512\"/>\n" +
    "                            <path d=\"M22.4056123,13.1169767 C22.0172965,10.9486047 20.2427351,7.55581395 15.2509982,7.55581395 C11.5348579,7.55581395 9.09640175,9.94813953 9.09640175,12.5602326 C9.09640175,14.7306977 10.4826474,16.4532558 13.3657877,17.01 L18.8564895,18.0648837 C26.0111035,19.4546512 29.837893,24.1262791 29.837893,29.6874419 C29.837893,35.7467442 24.7918754,41.8625581 15.639314,41.8625581 C5.21324386,41.8625581 0.609822807,35.1355814 0.00020877193,29.52 L7.09845439,27.63 C7.43248947,31.5209302 10.1486123,35.0246512 15.6956825,35.0246512 C19.7980509,35.0246512 22.0736649,32.9672093 22.0736649,30.1876744 C22.0736649,27.9062791 20.3533842,26.1272093 17.3032263,25.5160465 L11.8125246,24.4046512 C5.54519123,23.125814 1.49710351,19.0653488 1.49710351,13.1169767 C1.49710351,6.11162791 7.76443684,0.774418605 15.1967175,0.774418605 C24.735507,0.774418605 28.3952789,6.55534884 29.2825596,11.0051163 L22.4056123,13.1169767 Z\" id=\"Fill-2\"/>\n" +
    "                            <path d=\"M52.2984123,34.6349302 C56.0145526,34.6349302 58.2337982,32.6884186 58.2337982,29.5195814 C58.2337982,26.4051628 56.2358509,24.2367907 52.4090614,24.2367907 L46.0874474,24.2367907 L46.0874474,34.6349302 L52.2984123,34.6349302 Z M51.5217807,17.8991163 C55.0166228,17.8991163 57.1252193,15.9526047 57.1252193,12.9512093 C57.1252193,9.94772093 55.1836404,8.05772093 51.4675,8.05772093 L46.0874474,8.05772093 L46.0874474,17.8991163 L51.5217807,17.8991163 Z M52.6867281,1.60702326 C60.340307,1.60702326 64.6660614,6.1112093 64.6660614,12.2270233 C64.6660614,16.2853953 62.2255175,19.5672558 58.9540614,20.6786512 C62.7808509,21.6246977 65.8873772,25.1284186 65.8873772,30.019814 C65.8873772,36.414 61.1169386,41.0291163 53.7410263,41.0291163 L38.5445175,41.0291163 L38.5445175,1.60702326 L52.6867281,1.60702326 Z\" id=\"Fill-4\"/>\n" +
    "                            <polygon id=\"Fill-6\" points=\"18.7521035 67.5150698 8.88345439 67.5150698 8.88345439 57.7846047 26.0779105 57.7846047 26.0779105 50.5008837 1.22987544 50.5008837 1.22987544 89.9229767 8.93982281 89.9229767 8.93982281 74.5769302 18.7521035 74.5769302\"/>\n" +
    "                        </g>\n" +
    "                    </g>\n" +
    "                </g>\n" +
    "            </svg>";


$(document).ready(function () {

    var submitClicked = false;


    $('#sbfPortfolioSearchForm').on('submit', function(e){

        var formDataCategory = $('#tx_sbfportfolio_filtersearch_category').val();
        var formDataRegion = $('#tx_sbfportfolio_filtersearch_region').val();

        localStorage.setItem("category", formDataCategory);
        localStorage.setItem("region", formDataRegion);

    });

    if($('#sbfPortfolioFilterForm').length > 0) {
        $('#Category option[value='+localStorage.getItem("category")+']').attr('selected','selected');
        $('#Region option[value='+localStorage.getItem("region")+']').attr('selected','selected');

        $('#Category').next('.select-selected').html($('#Category').find(":selected").text());
        $('#Region').next('.select-selected').html($('#Region').find(":selected").text());
    }

    //submitform on upload
    $('.upload-new-image').on('change', function () {
        $('#imageUploadForm').submit();
    });

    // filter on page
    $("#sbfPortfolioFilterForm").submit(function (event) {
        event.preventDefault();
        var form = $(this);
        var openlist = document.getElementById('listview').checked;
        var initial = false;
        submitClicked = true;
        submitAjax(form, openlist, initial);
        $("#sbfportfolio-form").css("display", "");
    });

    $(document).on("click", '.pager-page:not(.disabled)', function () {

        var form = $('#sbfPortfolioFilterForm');
        var page = $(this).data('page');
        var openlist = document.getElementById('listview').checked;

        if (submitClicked === false) {
            var initial = true;
        }
        else {
            var initial = false;
        }

        //var initial = true;
        $(form).find('input[name="tx_sbfportfolio_filtersearch[page]"]').val(page);

        submitAjax(form, openlist, initial, 1);
    });

  /**
   * Load more cards on scroll
   */
  $(window).on('scroll', function (e) {
    var form = $('#sbfPortfolioFilterForm');
    var container = form.closest('.tx-sbf-portfolio')

    if($(window).scrollTop() + $(window).height() > container.offset().top + container.height() - 100) {
      if(loadingelementsOnScroll == 0) {
        loadingelementsOnScroll = 1;
        var page = container.find('.pager-page:not(.disabled)').data('page');
        if(page) {
          var openlist = document.getElementById('listview').checked;

          if (submitClicked === false) {
            var initial = true;
          }
          else {
            var initial = false;
          }

          //var initial = true;
          $(form).find('input[name="tx_sbfportfolio_filtersearch[page]"]').val(page);
          submitAjax(form, openlist, initial, 1);
        } else {
          setTimeout(
            function() {
              loadingelementsOnScroll = 0;
            }, 1000);
        }
      }
    }
  });

    $('.validateMessage').html();

    var initial = true;
    submitAjax($("#sbfPortfolioFilterForm"), false, initial);


    $(".toggle-button-filter-form").click(function () {
        $("#sbfportfolio-form").slideToggle();
        if ($(this).children("a").hasClass('arrow-up')) {
            $(this).children("a").removeClass('arrow-up').addClass('arrow-down');
        } else {
            $(this).children("a").addClass('arrow-up');
        }
        return false;
    });
});

function submitAjax(form, openlist, initial, append = 0) {
  if(append == 1) {
    $(".sbfportfolio-results-pager").prepend(loaderCode);
  } else {
    $("#sbfportfolio-results").html(loaderCode);
  }

    if (typeof form.attr('action') == 'undefined') {
        return;
    }
    var url = $(form).attr('action');

    var data = {};
    var map;

    var $this = $(this);
    // get caritas selects
    form.find('.sbfselect option:selected').each(function () {
        data[$(this).parent().attr('name')] = $(this).attr('value');
    });

    // get inputs
    $(form).find('input').each(function (index, element) {
        var value, $this = $(element), name = $this.attr('name');

        if ($("#initial").length && initial === true) {
            $("#initial").val(1);
        }
        else {
            $("#initial").val(0);
        }

        if (typeof name !== 'undefined') {
            if ($this.attr('type') === 'checkbox') {
                value = $this.is(':checked') ? $this.val() : '0';
            } else {
                value = $this.val();
            }
            data[name] = value;
        }
    });

    $.post(url, data).done(function (html) {
      if(append == 1) {
        $('#sbfportfolio-results').find('.masonry').append($(html).find('.masonry').html())
        masonryWrapper.reloadMasonry('.masonry')
        $('#sbfportfolio-results').find('.sbfportfolio-results-pager').html($(html).find('.sbfportfolio-results-pager').html())
        setTimeout(
          function() {
            loadingelementsOnScroll = 0;
          }, 500);
      } else {
        $('#sbfportfolio-results').html(html);
      }

        if ($('#map').length > 0) {

            var defaultZoom = 13;

            if(typeof variableZoom != 'undefined') {
                var zoom = variableZoom;
            }else {
                var zoom = defaultZoom;
            }

            window.setTimeout(initMap(zoom), 750);
        } else {
            window.setTimeout(activate_masonry, 750);
        }
    });

}

function initMap(zoom) {
    GoogleMapsLoader.load(function (google) {
        if(typeof bigLat !== 'undefined') {
            latlng = new google.maps.LatLng(bigLat ,bigLong);
        }else {
            return false;
        }
        var map = new google.maps.Map(document.getElementById('map'), {
            center: latlng,
            streetViewControl: false,
            zoom: zoom,
            styles: [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#bdbdbd"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dadada"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#c9c9c9"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                }
            ]
        });

        var markers = [];

        var dot = {
            path: 'M8,10a2,2 0 1,0 4,0a2,2 0 1,0 -4,0',
            fillColor: 'black',
            fillOpacity: 1,
            scale: 1,
            strokeColor: 'black',
            strokeWeight: 14
        };

        $.each(userJson, function(key, data) {
            var infowindow = new google.maps.InfoWindow({
                content: data.content
            });
            var latLng = new google.maps.LatLng(data.lat, data.long);
            // Creating a marker and putting it on the map
            var marker = new google.maps.Marker({
                position: latLng,
                title: data.title,
                icon: dot,
                infowindow: infowindow
            });

            google.maps.event.addListener(marker, 'click', function() {
                hideAllInfoWindows(map);
                this.infowindow.open(map, this);
            });

            google.maps.event.addListener(map, "click", function(event) {
                infowindow.close();
            });

            markers.push(marker);
        });

        function hideAllInfoWindows(map) {
            markers.forEach(function(marker) {
                marker.infowindow.close(map, marker);
            });
        }


        // Add a marker clusterer to manage the markers.
        var clusterStyles = [
            {
                textColor: 'white',
                url: '/typo3conf/ext/sbf_portfolio/Resources/Public/Icons/cluster-circle.svg',
                height: 50,
                width: 50,
                textSize:16,
            },
            {
                textColor: 'white',
                url: '/typo3conf/ext/sbf_portfolio/Resources/Public/Icons/cluster-circle.svg',
                height: 50,
                width: 50,
                textSize:16,
            },
            {
                textColor: 'white',
                url: '/typo3conf/ext/sbf_portfolio/Resources/Public/Icons/cluster-circle.svg',
                height: 50,
                width: 50,
                textSize:16,

            }
        ];

        var mcOptions = {
            gridSize: 50,
            styles: clusterStyles,
            maxZoom: 15,
        };
        var mc = new MarkerClusterer(map, markers, mcOptions);
    });

    $('reset-button').on('click', function () {
        $(".select-items > div:first-of-type").click();
    });

}



function activate_masonry() {
	masonryWrapper.loadMasonry('.masonry')
};
